import { render, staticRenderFns } from "./NotificationTemplates.vue?vue&type=template&id=2589c884&scoped=true"
import script from "./NotificationTemplates.vue?vue&type=script&lang=js"
export * from "./NotificationTemplates.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplates.vue?vue&type=style&index=0&id=2589c884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589c884",
  null
  
)

export default component.exports